import { render } from "./WorkflowDetails.vue?vue&type=template&id=94cff62e"
import script from "./WorkflowDetails.vue?vue&type=script&lang=js"
export * from "./WorkflowDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__